var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._t("form-read"),
      _vm._v(" "),
      _vm._t("form-field"),
      _vm._v(" "),
      _vm.allBtnShow
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-12" }, [
              _c(
                "div",
                { staticClass: "form-actions" },
                [
                  _vm._t("extraBtn"),
                  _vm._v(" "),
                  _vm.btnExport.show &&
                  ((_vm.menuRights || {}).isreadonly || 0) == 0
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-sm btn-instagram",
                          attrs: { disabled: _vm.btnExport.disabled },
                          on: { click: _vm.btnExportClick },
                        },
                        [
                          _c("i", { staticClass: "fas fa-cloud-download-alt" }),
                          _vm._v(" "),
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.ui.export_excel || "Export Document (Excel)"
                              ),
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.btnImport.show
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-sm bg-olive",
                          attrs: { disabled: _vm.btnImport.disabled },
                          on: { click: _vm.btnImportClick },
                        },
                        [
                          _c("i", { staticClass: "fas fa-cloud-upload-alt" }),
                          _vm._v(" "),
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.ui.import_excel || "Import (Excel)"
                              ),
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.btnImport_center.show
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-sm bg-olive",
                          attrs: { disabled: _vm.btnImport_center.disabled },
                          on: { click: _vm.btnImportClick_Center },
                        },
                        [
                          _c("i", { staticClass: "fas fa-cloud-upload-alt" }),
                          _vm._v(" "),
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.ui.import_excel || "Import (Excel)"
                              ),
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.btnRetrieve.show
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-sm btn-facebook",
                          attrs: { disabled: _vm.btnRetrieve.disabled },
                          on: { click: _vm.btnRetrieveClick },
                        },
                        [
                          _c("i", { staticClass: "fas fa-list" }),
                          _vm._v(" "),
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.ui.retrieve || "Retrieve"
                              ),
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.btnNew.show &&
                  ((_vm.menuRights || {}).isreadonly || 0) == 0
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-sm btn-linkedin",
                          attrs: { disabled: _vm.btnNew.disabled },
                          on: { click: _vm.btnNewClick },
                        },
                        [
                          _c("i", { staticClass: "fas fa-plus" }),
                          _vm._v(" "),
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(_vm.ui.new || "New"),
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.btnSave.show &&
                  ((_vm.menuRights || {}).isreadonly || 0) == 0
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-sm btn-success",
                          attrs: { disabled: _vm.btnSave.disabled },
                          on: { click: _vm.btnSaveClick },
                        },
                        [
                          _c("i", { staticClass: "fas fa-save" }),
                          _vm._v(" "),
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(_vm.ui.save || "Save"),
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.btnDelete.show &&
                  ((_vm.menuRights || {}).isreadonly || 0) == 0
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-sm btn-danger",
                          attrs: { disabled: _vm.btnDelete.disabled },
                          on: { click: _vm.btnDeleteClick },
                        },
                        [
                          _c("i", { staticClass: "fas fa-trash" }),
                          _vm._v(" "),
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(_vm.ui.delete || "Delete"),
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                ],
                2
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: false,
            expression: "false",
          },
        ],
        ref: "File",
        attrs: { type: "file", accept: ".xls, .xlsx" },
      }),
      _vm._v(" "),
      _vm._t("form-detail"),
      _vm._v(" "),
      _c("loading-box", { ref: "myLB" }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }